export enum permissionType {
  Authenticated = 1,
  Administrator = 2,
}

export enum UserSettingsBaseEnum {
  user_list = "user.list",
  master_vehicle_list = "master.vehicle.list",
}

export enum JobStatus {
  BidInProgress = 1,
  BidSubmitted = 2,
  BidAccepted = 3,
  JobInProgress = 4,
  JobComplete = 5,
  NotAwarded = 6,
  NoBid = 7,
  SeeNotesColumn = 8,
  Invoiced = 9,
  Paid = 10,
  PartiallyPaid = 11,
  InvoicedSeeNotesColumn = 12,
}

export enum WhereToUpload {}
